import { environment } from "src/environments/environment.development";

export const URL_BACKEND = environment.URL_BACKEND
export const URL_SERVICIOS = environment.URL_SERVICIOS
export const URL_FRONTEND = environment.URL_FRONTEND